export class AppConfigs {
    // public static API_ENDPOINT = 'http://coinmaster.local:8888/api/';    
    // public static API_ENDPOINT = 'http://127.0.0.1:8000/api/';
    // public static API_ENDPOINT = 'http://localhost/api/';
    // public static API_ENDPOINT = '/api/';
    public static API_ENDPOINT = 'https://offers.xsrv.jp/api/';
    // public static API_ENDPOINT = 'http://offers2.xsrv.jp/api/';
    // public static API_ENDPOINT = 'http://offers3.xsrv.jp/api/';
    // public static API_ENDPOINT = 'https://bitlion-api.com/api/';
    // public static User = { name: ""};

    // Role permission User
    public static ACL_AD = 'ACL_AD';
    public static ACL_U1 = 'ACL_U1';
    // user not connect line bot with deny
    public static ACL_CONNECT_LINE = [AppConfigs.ACL_U1];
    public static ACL_CONNECT_TWITTER = [AppConfigs.ACL_U1];

    // Default Image avatar user
    public static DEFAULT_IMG_AVATAR = 'assets/img/bitcoinLogo.png';
    public static URL_USER_NOT_CONNECT = '/profile-user';

    // Zone time
    public static TIME_ZONE = 'Asia/Tokyo';
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/app.config.ts